import React, { useEffect, useState } from 'react';
import About from './pages/About/About';
import Projects from './pages/Projects/Projects';
import Contact from './pages/Contact/Contact';
import Blog from './pages/Blog/Blog';
import Hero from './components/Home/Hero';
import { useInView } from 'react-intersection-observer';
import Chatbot from './components/Chatbot/Chatbot';
import ScrollIndicator from './components/ScrollIndicator/ScrollIndicator';

function Main() {
  const [activeSection, setActiveSection] = useState('hero');

  const [aboutRef, aboutRefInView] = useInView({ threshold: 0.2 });
  const [projectsRef, projectsRefInView] = useInView({ threshold: 0.3 });
  const [contactRef, contactRefInView] = useInView({ threshold: 0.1 });
  const [blogRef, blogRefInView] = useInView({ threshold: 0.3 });

  useEffect(() => {
    if (aboutRefInView) setActiveSection('about');
    else if (projectsRefInView) setActiveSection('projects');
    else if (blogRefInView) setActiveSection('blog');
    else if (contactRefInView) setActiveSection('contact');
    else setActiveSection('hero');
  }, [aboutRefInView, projectsRefInView, contactRefInView, blogRefInView]);


return (
    <>
      <Hero />
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={projectsRef}>
        <Projects />
      </div>
      <div ref={blogRef}>
        <Blog />
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>
      <Chatbot />
      <ScrollIndicator activeSection={activeSection} />
    </>
  );
}

export default Main;
